export enum EContactMethods {
  PHONE = 'phone',
  TEXT = 'text',
  EMAIL = 'email'
}
